const init = () => {
    const contactFilterSelections = document.querySelectorAll(".search-hero__form--contact-form .search-hero__input--select");
    if (!contactFilterSelections)
        return

    contactFilterSelections.forEach(option => {
        option.addEventListener('change', (e) => {
            const branchBtn = document.querySelector('#branch-button span');
            let branchName = null;
            if (branchBtn) {
                branchName = branchBtn.innerText.toLowerCase();
                branchName = branchBtn.innerText.toUpperCase().includes('bransch') ? null : branchName.charAt(0).toUpperCase() + branchName.slice(1).toLowerCase()
            }

            const filtertype = e.currentTarget.id
            const filterEvent = e.target.selectedOptions[0].text
            const isAuthenticated = String(window.authenticated)
            const selectedBranch = branchName

            dataLayer.push({
                'event': 'coworkerFilter',
                'filterTyp': filtertype.charAt(0).toUpperCase() + filtertype.slice(1).toLowerCase(),
                'filterValue': filterEvent,
                'isAuthenticated': isAuthenticated.charAt(0).toUpperCase() + isAuthenticated.slice(1).toLowerCase(),
                'selectedBranch': selectedBranch,
            });
        })
    })
}

document.addEventListener("DOMContentLoaded", () => init())
